const config = {
    host: 'https://mi-api.funnynovel.com/api',//release
    //host: 'https://test-api.funnynovel.com/api',//release
    //host: 'http://mi-api.ycsd.cn/api',//develop
}

export default config;


// WEBPACK FOOTER //
// ./src/api/config.js